/* eslint-disable react/style-prop-object */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl ,hreftag }) => {
  return (
    <Col size={12} sm={3} md={3}>
    <div className="proj-imgbx">
    <a href={hreftag} target="_blank" >
    <img src={imgUrl} />
    <div className="proj-txtx">
    <h4>{title}</h4>
    <span>{description}</span>
    </div>
    </a>
    </div>
    </Col>
  )
}
